var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Common/getClassifierIcon.tsx";
import { CalculateIcon, Checkup, CheckupFilled, EstimationFilled } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export function getClassifierIcon(node) {
  if (node.type === 'UserClassifierNode') {
    return /*#__PURE__*/_jsx(Checkup, {});
  }

  switch (node.componentType) {
    case 'Checkup':
      return /*#__PURE__*/_jsx(CheckupFilled, {});

    case 'Estimation':
      return /*#__PURE__*/_jsx(CalculateIcon, {});

    case 'FieldInspection':
      //Icon from explorer
      return /*#__PURE__*/_jsx(EstimationFilled, {});

    default:
      throw new Error("Unexpected type: ".concat(node.componentType));
  }
}